(function ($) {
  $(document).ready(function () {
    const activeClass = 'checked';
    const groupClass = '.js-checkout-radio-group';

    $(document).on('change', '.js-checkout-radio-input', function () {
      $_this = $(this);

      if ($_this.is(':checked')) {
        $_this.addClass(activeClass);

        const parentOption = $_this.parents('.js-checkout-radio-option');
        if (parentOption.length) {
          parentOption.addClass(activeClass);
        }

        const parentGroup = $_this.parents(groupClass);
        if (parentGroup.length) {
          parentGroup.addClass(activeClass);
        }
      }
    });

    $(document).on('click', '.js-checkout-radio-reset', function (e) {
      e.preventDefault();
      const parentGroup = $(this).parents(groupClass);

      if (parentGroup.length) {
        parentGroup.removeClass(activeClass);
        parentGroup.find('.' + activeClass).removeClass(activeClass);
        parentGroup.find('.js-checkout-radio-input').prop('checked', false);
      }
    });
  });
})(jQuery);
